import type { DocMigration } from "../docMigration";

const arialNarrowMetrics = {
  fontMetrics: {
    fontName: "Arial Narrow",
    unitsPerEm: 2048,
    ascender: 1916,
    descender: -434,
    lineGap: 0,
    xHeight: null,
    capHeight: null,
  },
  advanceWidths: {
    "32": 467,
    "33": 467,
    "34": 596,
    "35": 934,
    "36": 934,
    "37": 1493,
    "38": 1120,
    "39": 322,
    "40": 559,
    "41": 559,
    "42": 653,
    "43": 981,
    "44": 467,
    "45": 559,
    "46": 467,
    "47": 467,
    "48": 934,
    "49": 934,
    "50": 934,
    "51": 934,
    "52": 934,
    "53": 934,
    "54": 934,
    "55": 934,
    "56": 934,
    "57": 934,
    "58": 467,
    "59": 467,
    "60": 981,
    "61": 981,
    "62": 981,
    "63": 934,
    "64": 1704,
    "65": 1120,
    "66": 1120,
    "67": 1212,
    "68": 1212,
    "69": 1120,
    "70": 1026,
    "71": 1307,
    "72": 1212,
    "73": 467,
    "74": 840,
    "75": 1120,
    "76": 934,
    "77": 1399,
    "78": 1212,
    "79": 1307,
    "80": 1120,
    "81": 1307,
    "82": 1212,
    "83": 1120,
    "84": 1026,
    "85": 1212,
    "86": 1120,
    "87": 1585,
    "88": 1120,
    "89": 1120,
    "90": 1026,
    "91": 467,
    "92": 467,
    "93": 467,
    "94": 788,
    "95": 934,
    "96": 559,
    "97": 934,
    "98": 934,
    "99": 840,
    "100": 934,
    "101": 934,
    "102": 467,
    "103": 934,
    "104": 934,
    "105": 373,
    "106": 373,
    "107": 840,
    "108": 373,
    "109": 1399,
    "110": 934,
    "111": 934,
    "112": 934,
    "113": 934,
    "114": 559,
    "115": 840,
    "116": 467,
    "117": 934,
    "118": 840,
    "119": 1212,
    "120": 840,
    "121": 840,
    "122": 840,
    "123": 561,
    "124": 436,
    "125": 561,
    "126": 981,
    "160": 467,
    "161": 559,
    "162": 934,
    "163": 934,
    "164": 934,
    "165": 934,
    "166": 436,
    "167": 934,
    "168": 559,
    "169": 1237,
    "170": 621,
    "171": 934,
    "172": 981,
    "173": 559,
    "174": 1237,
    "175": 1024,
    "176": 819,
    "177": 1124,
    "178": 559,
    "179": 559,
    "180": 559,
    "181": 1180,
    "182": 901,
    "183": 557,
    "184": 559,
    "185": 559,
    "186": 612,
    "187": 934,
    "188": 1401,
    "189": 1401,
    "190": 1401,
    "191": 1026,
    "192": 1120,
    "193": 1120,
    "194": 1120,
    "195": 1120,
    "196": 1120,
    "197": 1120,
    "198": 1679,
    "199": 1212,
    "200": 1120,
    "201": 1120,
    "202": 1120,
    "203": 1120,
    "204": 467,
    "205": 467,
    "206": 467,
    "207": 467,
    "208": 1212,
    "209": 1212,
    "210": 1307,
    "211": 1307,
    "212": 1307,
    "213": 1307,
    "214": 1307,
    "215": 981,
    "216": 1307,
    "217": 1212,
    "218": 1212,
    "219": 1212,
    "220": 1212,
    "221": 1120,
    "222": 1120,
    "223": 1026,
    "224": 934,
    "225": 934,
    "226": 934,
    "227": 934,
    "228": 934,
    "229": 934,
    "230": 1493,
    "231": 840,
    "232": 934,
    "233": 934,
    "234": 934,
    "235": 934,
    "236": 467,
    "237": 467,
    "238": 467,
    "239": 467,
    "240": 934,
    "241": 934,
    "242": 934,
    "243": 934,
    "244": 934,
    "245": 934,
    "246": 934,
    "247": 1124,
    "248": 1026,
    "249": 934,
    "250": 934,
    "251": 934,
    "252": 934,
    "253": 840,
    "254": 934,
    "255": 840,
    "256": 1120,
    "257": 934,
    "258": 1120,
    "259": 934,
    "260": 1120,
    "261": 934,
    "262": 1212,
    "263": 840,
    "264": 1212,
    "265": 840,
    "266": 1212,
    "267": 840,
    "268": 1212,
    "269": 840,
    "270": 1212,
    "271": 1032,
    "272": 1212,
    "273": 928,
    "274": 1120,
    "275": 934,
    "276": 1120,
    "277": 934,
    "278": 1120,
    "279": 934,
    "280": 1120,
    "281": 934,
    "282": 1120,
    "283": 934,
    "284": 1307,
    "285": 934,
    "286": 1307,
    "287": 934,
    "288": 1307,
    "289": 934,
    "290": 1307,
    "291": 934,
    "292": 1212,
    "293": 934,
    "294": 1212,
    "295": 934,
    "296": 467,
    "297": 467,
    "298": 467,
    "299": 467,
    "300": 467,
    "301": 467,
    "302": 467,
    "303": 373,
    "304": 467,
    "305": 467,
    "306": 1307,
    "307": 746,
    "308": 840,
    "309": 373,
    "310": 1120,
    "311": 840,
    "312": 836,
    "313": 934,
    "314": 373,
    "315": 934,
    "316": 373,
    "317": 934,
    "318": 489,
    "319": 934,
    "320": 661,
    "321": 934,
    "322": 373,
    "323": 1212,
    "324": 934,
    "325": 1212,
    "326": 934,
    "327": 1212,
    "328": 934,
    "329": 1173,
    "330": 1212,
    "331": 934,
    "332": 1307,
    "333": 934,
    "334": 1307,
    "335": 934,
    "336": 1307,
    "337": 934,
    "338": 1679,
    "339": 1585,
    "340": 1212,
    "341": 559,
    "342": 1212,
    "343": 559,
    "344": 1212,
    "345": 559,
    "346": 1120,
    "347": 840,
    "348": 1120,
    "349": 840,
    "350": 1120,
    "351": 840,
    "352": 1120,
    "353": 840,
    "354": 1026,
    "355": 467,
    "356": 1026,
    "357": 629,
    "358": 1026,
    "359": 468,
    "360": 1212,
    "361": 934,
    "362": 1212,
    "363": 934,
    "364": 1212,
    "365": 934,
    "366": 1212,
    "367": 934,
    "368": 1212,
    "369": 934,
    "370": 1212,
    "371": 934,
    "372": 1585,
    "373": 1212,
    "374": 1120,
    "375": 840,
    "376": 1120,
    "377": 1026,
    "378": 840,
    "379": 1026,
    "380": 840,
    "381": 1026,
    "382": 840,
    "383": 373,
    "402": 934,
    "506": 1120,
    "507": 934,
    "508": 1679,
    "509": 1493,
    "510": 1307,
    "511": 1026,
    "536": 1120,
    "537": 840,
    "538": 1026,
    "539": 467,
    "710": 559,
    "711": 559,
    "713": 559,
    "728": 559,
    "729": 559,
    "730": 559,
    "731": 559,
    "732": 559,
    "733": 559,
    "894": 467,
    "900": 559,
    "901": 559,
    "902": 1120,
    "903": 682,
    "904": 1365,
    "905": 1469,
    "906": 711,
    "908": 1437,
    "910": 1480,
    "911": 1392,
    "912": 467,
    "913": 1120,
    "914": 1120,
    "915": 897,
    "916": 1145,
    "917": 1120,
    "918": 1026,
    "919": 1212,
    "920": 1229,
    "921": 467,
    "922": 1120,
    "923": 1120,
    "924": 1399,
    "925": 1212,
    "926": 1092,
    "927": 1307,
    "928": 1212,
    "929": 1120,
    "931": 1012,
    "932": 1026,
    "933": 1120,
    "934": 1357,
    "935": 1120,
    "936": 1352,
    "937": 1274,
    "938": 467,
    "939": 1120,
    "940": 1013,
    "941": 729,
    "942": 934,
    "943": 467,
    "944": 934,
    "945": 1013,
    "946": 944,
    "947": 840,
    "948": 934,
    "949": 729,
    "950": 737,
    "951": 934,
    "952": 934,
    "953": 467,
    "954": 836,
    "955": 840,
    "956": 934,
    "957": 840,
    "958": 643,
    "959": 934,
    "960": 1139,
    "961": 958,
    "962": 793,
    "963": 1117,
    "964": 641,
    "965": 934,
    "966": 1090,
    "967": 877,
    "968": 1223,
    "969": 1286,
    "970": 467,
    "971": 934,
    "972": 934,
    "973": 934,
    "974": 1286,
    "1025": 1120,
    "1026": 1453,
    "1027": 897,
    "1028": 1207,
    "1029": 1120,
    "1030": 467,
    "1031": 467,
    "1032": 840,
    "1033": 1775,
    "1034": 1696,
    "1035": 1434,
    "1036": 977,
    "1038": 1066,
    "1039": 1207,
    "1040": 1120,
    "1041": 1102,
    "1042": 1120,
    "1043": 897,
    "1044": 1137,
    "1045": 1120,
    "1046": 1550,
    "1047": 1014,
    "1048": 1207,
    "1049": 1207,
    "1050": 977,
    "1051": 1102,
    "1052": 1399,
    "1053": 1212,
    "1054": 1307,
    "1055": 1212,
    "1056": 1120,
    "1057": 1212,
    "1058": 1026,
    "1059": 1066,
    "1060": 1276,
    "1061": 1120,
    "1062": 1243,
    "1063": 1120,
    "1064": 1540,
    "1065": 1575,
    "1066": 1330,
    "1067": 1569,
    "1068": 1102,
    "1069": 1207,
    "1070": 1696,
    "1071": 1212,
    "1072": 934,
    "1073": 962,
    "1074": 892,
    "1075": 613,
    "1076": 979,
    "1077": 934,
    "1078": 1123,
    "1079": 769,
    "1080": 939,
    "1081": 934,
    "1082": 734,
    "1083": 979,
    "1084": 1155,
    "1085": 927,
    "1086": 934,
    "1087": 910,
    "1088": 934,
    "1089": 840,
    "1090": 769,
    "1091": 840,
    "1092": 1382,
    "1093": 840,
    "1094": 962,
    "1095": 875,
    "1096": 1347,
    "1097": 1382,
    "1098": 1049,
    "1099": 1249,
    "1100": 875,
    "1101": 857,
    "1102": 1259,
    "1103": 910,
    "1105": 934,
    "1106": 934,
    "1107": 613,
    "1108": 857,
    "1109": 840,
    "1110": 373,
    "1111": 467,
    "1112": 373,
    "1113": 1522,
    "1114": 1364,
    "1115": 934,
    "1116": 734,
    "1118": 840,
    "1119": 927,
    "1168": 831,
    "1169": 553,
    "7808": 1585,
    "7809": 1212,
    "7810": 1585,
    "7811": 1212,
    "7812": 1585,
    "7813": 1212,
    "7922": 1120,
    "7923": 840,
    "8211": 934,
    "8212": 1679,
    "8213": 1679,
    "8215": 1024,
    "8216": 373,
    "8217": 373,
    "8218": 373,
    "8219": 373,
    "8220": 559,
    "8221": 559,
    "8222": 559,
    "8224": 934,
    "8225": 934,
    "8226": 588,
    "8230": 1679,
    "8240": 1679,
    "8242": 322,
    "8243": 596,
    "8249": 559,
    "8250": 559,
    "8252": 934,
    "8254": 934,
    "8260": 281,
    "8319": 612,
    "8355": 1032,
    "8356": 934,
    "8359": 1952,
    "8364": 934,
    "8453": 1553,
    "8467": 715,
    "8470": 1802,
    "8482": 1679,
    "8486": 1573,
    "8494": 1229,
    "8539": 1401,
    "8540": 1401,
    "8541": 1401,
    "8542": 1401,
    "8592": 2048,
    "8593": 1024,
    "8594": 2048,
    "8595": 1024,
    "8596": 2048,
    "8597": 1024,
    "8616": 1024,
    "8706": 1012,
    "8710": 1253,
    "8719": 1686,
    "8721": 1460,
    "8722": 981,
    "8725": 281,
    "8729": 467,
    "8730": 1124,
    "8734": 1460,
    "8735": 2005,
    "8745": 1479,
    "8747": 561,
    "8776": 1124,
    "8800": 1124,
    "8801": 979,
    "8804": 1124,
    "8805": 1124,
    "8962": 1229,
    "8976": 981,
    "8992": 1237,
    "8993": 1237,
    "9472": 1451,
    "9474": 1261,
    "9484": 1451,
    "9488": 1451,
    "9492": 1451,
    "9496": 1451,
    "9500": 1451,
    "9508": 1451,
    "9516": 1451,
    "9524": 1451,
    "9532": 1451,
    "9552": 1451,
    "9553": 1451,
    "9554": 1451,
    "9555": 1451,
    "9556": 1451,
    "9557": 1451,
    "9558": 1451,
    "9559": 1451,
    "9560": 1451,
    "9561": 1451,
    "9562": 1451,
    "9563": 1451,
    "9564": 1451,
    "9565": 1451,
    "9566": 1451,
    "9567": 1451,
    "9568": 1451,
    "9569": 1451,
    "9570": 1451,
    "9571": 1451,
    "9572": 1451,
    "9573": 1451,
    "9574": 1451,
    "9575": 1451,
    "9576": 1451,
    "9577": 1451,
    "9578": 1451,
    "9579": 1451,
    "9580": 1451,
    "9600": 1451,
    "9604": 1451,
    "9608": 1451,
    "9612": 1451,
    "9616": 1451,
    "9617": 1451,
    "9618": 1451,
    "9619": 1493,
    "9632": 1237,
    "9633": 1237,
    "9642": 726,
    "9643": 726,
    "9644": 2048,
    "9650": 2027,
    "9658": 2027,
    "9660": 2027,
    "9668": 2027,
    "9674": 1012,
    "9675": 1237,
    "9679": 1237,
    "9688": 1237,
    "9689": 1237,
    "9702": 726,
    "9786": 2091,
    "9787": 2155,
    "9788": 1877,
    "9792": 1536,
    "9794": 1536,
    "9824": 1088,
    "9827": 1344,
    "9829": 1216,
    "9830": 1045,
    "9834": 1024,
    "9835": 1536,
    "64257": 840,
    "64258": 840,
  },
  kerningPairs: {
    "32,65": -92,
    "160,65": -92,
    "32,84": -29,
    "160,84": -29,
    "32,89": -29,
    "160,89": -29,
    "32,260": -92,
    "160,260": -92,
    "32,354": -29,
    "160,354": -29,
    "32,356": -29,
    "160,356": -29,
    "49,49": -123,
    "65,32": -92,
    "65,160": -92,
    "65,84": -123,
    "65,86": -123,
    "65,87": -61,
    "65,89": -123,
    "65,118": -29,
    "65,119": -29,
    "65,121": -29,
    "65,8217": -123,
    "65,354": -123,
    "65,356": -123,
    "70,44": -186,
    "70,46": -186,
    "70,65": -92,
    "70,260": -92,
    "76,32": -61,
    "76,160": -61,
    "76,84": -123,
    "76,86": -123,
    "76,87": -123,
    "76,89": -123,
    "76,121": -61,
    "76,8217": -92,
    "76,354": -123,
    "76,356": -123,
    "80,32": -29,
    "80,160": -29,
    "80,44": -215,
    "80,46": -215,
    "80,65": -123,
    "80,260": -123,
    "82,84": -29,
    "82,86": -29,
    "82,87": -29,
    "82,89": -29,
    "82,354": -29,
    "82,356": -29,
    "84,32": -29,
    "84,160": -29,
    "84,44": -186,
    "84,45": -92,
    "84,173": -92,
    "84,46": -186,
    "84,58": -186,
    "84,59": -186,
    "84,894": -186,
    "84,65": -123,
    "84,79": -29,
    "84,97": -186,
    "84,99": -186,
    "84,101": -186,
    "84,105": -37,
    "84,111": -186,
    "84,114": -61,
    "84,115": -143,
    "84,117": -61,
    "84,119": -92,
    "84,121": -92,
    "84,260": -123,
    "84,261": -186,
    "84,281": -186,
    "84,336": -29,
    "86,44": -154,
    "86,45": -92,
    "86,173": -92,
    "86,46": -154,
    "86,58": -61,
    "86,59": -61,
    "86,894": -61,
    "86,65": -123,
    "86,97": -123,
    "86,101": -92,
    "86,105": -29,
    "86,111": -92,
    "86,114": -61,
    "86,117": -61,
    "86,121": -61,
    "86,260": -123,
    "86,261": -123,
    "86,281": -92,
    "87,44": -92,
    "87,45": -29,
    "87,173": -29,
    "87,46": -92,
    "87,58": -29,
    "87,59": -29,
    "87,894": -29,
    "87,65": -61,
    "87,97": -61,
    "87,101": -29,
    "87,105": 0,
    "87,111": -29,
    "87,114": -29,
    "87,117": -29,
    "87,121": -14,
    "87,260": -61,
    "87,261": -61,
    "87,281": -29,
    "89,32": -29,
    "89,160": -29,
    "89,44": -215,
    "89,45": -154,
    "89,173": -154,
    "89,46": -215,
    "89,58": -92,
    "89,59": -109,
    "89,894": -109,
    "89,65": -123,
    "89,97": -123,
    "89,101": -154,
    "89,105": -61,
    "89,111": -154,
    "89,112": -123,
    "89,113": -154,
    "89,117": -92,
    "89,118": -92,
    "89,260": -123,
    "89,261": -123,
    "89,281": -154,
    "102,102": -29,
    "102,8217": 29,
    "114,44": -92,
    "114,46": -92,
    "114,8217": 61,
    "118,44": -123,
    "118,46": -123,
    "119,44": -92,
    "119,46": -92,
    "121,44": -123,
    "121,46": -123,
    "8216,8216": -29,
    "8217,32": -61,
    "8217,160": -61,
    "8217,115": -29,
    "8217,8217": -29,
    "260,32": -92,
    "260,160": -92,
    "260,84": -123,
    "260,86": -123,
    "260,87": -61,
    "260,89": -123,
    "260,118": -29,
    "260,119": -29,
    "260,8217": -123,
    "260,354": -123,
    "260,356": -123,
    "313,32": -61,
    "313,160": -61,
    "313,84": -123,
    "313,86": -123,
    "313,87": -123,
    "313,89": -123,
    "313,121": -61,
    "313,8217": -92,
    "313,354": -123,
    "313,356": -123,
    "340,84": -29,
    "340,86": -29,
    "340,87": -29,
    "340,89": -29,
    "340,354": -29,
    "340,356": -29,
    "341,44": -92,
    "341,46": -92,
    "341,8217": 61,
    "344,84": -29,
    "344,86": -29,
    "344,87": -29,
    "344,89": -29,
    "344,354": -29,
    "344,356": -29,
    "345,44": -92,
    "345,46": -92,
    "345,8217": 61,
    "354,32": -29,
    "354,160": -29,
    "354,44": -186,
    "354,45": -92,
    "354,173": -92,
    "354,46": -186,
    "354,58": -186,
    "354,59": -186,
    "354,894": -186,
    "354,65": -123,
    "354,79": -29,
    "354,97": -186,
    "354,99": -186,
    "354,101": -186,
    "354,105": -37,
    "354,111": -186,
    "354,114": -61,
    "354,115": -143,
    "354,117": -61,
    "354,119": -92,
    "354,121": -92,
    "354,260": -123,
    "354,261": -186,
    "354,281": -186,
    "354,336": -29,
    "356,32": -29,
    "356,160": -29,
    "356,44": -186,
    "356,45": -92,
    "356,173": -92,
    "356,46": -186,
    "356,58": -186,
    "356,59": -186,
    "356,894": -186,
    "356,65": -123,
    "356,79": -29,
    "356,97": -186,
    "356,99": -186,
    "356,101": -186,
    "356,105": -37,
    "356,111": -186,
    "356,114": -61,
    "356,115": -143,
    "356,117": -61,
    "356,119": -92,
    "356,121": -92,
    "356,260": -123,
    "356,261": -186,
    "356,281": -186,
    "356,336": -29,
  },
} as const;

const fontMultiplier = 1.3969986357435198;
const defaultPlanFontSize = 8 / (72 * fontMultiplier);
const defaultElevationFontSize = 10 / (72 * fontMultiplier);

function checkNaN(value: number, e: string): void {
  if (isNaN(value)) {
    throw new Error(e);
  }
}

function widthOfArialNarrowString(str: string, fontSize: number): number {
  let longest = 0;
  const spaceAdvanceWidth = arialNarrowMetrics.advanceWidths[32];
  for (const line of str.split("\n")) {
    let lineWidth = 0;
    let previous: string | undefined = undefined;
    for (const char of line.trimEnd()) {
      const advanceWidth =
        char.charCodeAt(0) === 9 ? spaceAdvanceWidth * 4 : arialNarrowMetrics.advanceWidths[char.charCodeAt(0)];

      if (isNaN(advanceWidth)) {
        console.warn("Note has non-printable character: " + char);
        continue;
      }

      lineWidth += advanceWidth;
      if (previous) {
        const kernPair = `${previous.charCodeAt(0)},${char.charCodeAt(0)}`;
        if (kernPair in arialNarrowMetrics.kerningPairs) {
          const kern = arialNarrowMetrics.kerningPairs[kernPair];
          checkNaN(kern, "kern: " + kernPair);
          lineWidth += kern;
        }
      }
      previous = char;
    }
    longest = Math.max(longest, lineWidth);
  }
  const fontScale = (fontSize * fontMultiplier) / arialNarrowMetrics.fontMetrics.unitsPerEm;
  return longest * fontScale;
}

function heightOfArialNarrowString(str: string, fontSize: number): number {
  const metrics = arialNarrowMetrics.fontMetrics;
  const fontScale = (fontSize * fontMultiplier) / metrics.unitsPerEm;
  const lineHeight = (metrics.ascender - metrics.descender + metrics.lineGap) * fontScale;
  const numLines = (str.trimEnd().match(/\n/g) || []).length + 1;
  return lineHeight * numLines;
}

function getElementFontSize(element: any, isElevationNote: boolean, defaultFontSize: number | undefined) {
  if (element.fontSize) {
    return element.fontSize;
  }

  if (defaultFontSize) {
    return defaultFontSize;
  }

  // We detect if the note is in an elevation view and use appropriate default font size.
  return isElevationNote ? defaultElevationFontSize : defaultPlanFontSize;
}

function migrateElements(
  elevationViewIds: string[],
  defaultFontSize: number | undefined,
  annotationScale: number,
  elements: any,
): void {
  for (const elementKey in elements) {
    const element = elements[elementKey];
    if (element.type === "NOTE") {
      if (element.definedSize) {
        delete element.definedSize;
      }
      if (!element.placementYAnchor) {
        element.placementYAnchor = "CENTER";
      }
      if (!element.verticalAlignment) {
        element.verticalAlignment = "CENTER";
      }
      const isElevationNote = element.parentId && elevationViewIds.includes(element.parentId);
      const fontSize = getElementFontSize(element, isElevationNote, defaultFontSize);
      checkNaN(fontSize, "fontSize");
      // scale up by annotation scale for non-elevation notes.
      const planScale = isElevationNote ? 1 : annotationScale;
      checkNaN(planScale, "planScale");
      // use a slight expansion to account for numerical error.
      const expansionFactor = 1.01;
      const boxScale = planScale * expansionFactor;
      checkNaN(boxScale, "boxScale");
      element.textBoxWidth = widthOfArialNarrowString(element.text, fontSize) * boxScale;
      checkNaN(element.textBoxWidth, "element.textBoxWidth");
      element.textBoxHeight = heightOfArialNarrowString(element.text, fontSize) * boxScale;
      checkNaN(element.textBoxHeight, "element.textBoxHeight");
    }
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_429: DocMigration = {
  maxSchemaVersion: "0.0.429",
  description: "For all notes, remove defined size flag and recalculate text box dimensions",
  apply(json: any) {
    // Find a maximum annotation scale to apply to the notes.
    let annotationScale = 1;
    for (const settingsKey in json.settings) {
      const settings = json.settings[settingsKey];
      if (settings.type === "PLAN_SETTINGS") {
        if (settings.annotationScale && settings.annotationScale > annotationScale) {
          annotationScale = settings.annotationScale;
        }
      }
    }

    // store ids of elevation views
    const elevationViewIds = Object.keys(json.elevationViews ?? {});
    const elevationTemplateIds: Array<string> = [];

    migrateElements(elevationViewIds, undefined, annotationScale, json.annotation);

    for (const annotationKey in json.annotation) {
      const anno = json.annotation[annotationKey];
      if (
        anno.type === "TEMPLATE_INSTANCE" &&
        anno.parentId &&
        elevationViewIds.includes(anno.parentId) &&
        !elevationTemplateIds.includes(anno.parentId)
      ) {
        elevationTemplateIds.push(anno.annotationTemplateId);
      }
    }

    for (const settingsKey in json.settings) {
      const settings = json.settings[settingsKey];
      if (settings.type === "ANNOTATION_CATALOG_SETTINGS") {
        for (const annotationTemplateKey in settings.annotationTemplates) {
          const defaultFontSize = elevationTemplateIds.includes(annotationTemplateKey)
            ? defaultElevationFontSize
            : defaultPlanFontSize;

          const annotationTemplate = settings.annotationTemplates[annotationTemplateKey];
          migrateElements(elevationViewIds, defaultFontSize, annotationScale, annotationTemplate.components);
        }
      }
    }

    return json;
  },
};

export default migration_0_0_429;
